import { imageUrl } from './api';

type Props = {
  imageName: string | null;
  alt: string;
};

// The annotated image lives on the server, so there is nothing to show when it was never
// stored. Say so rather than leaving an empty frame or a broken image icon.
export default function ResultImage({ imageName, alt }: Props) {
  return (
    <div className="preview-frame result-image">
      {imageName ? (
        <img src={imageUrl(imageName)} alt={alt} />
      ) : (
        <p className="message warning">
          Picture not stored on the server — image storage is probably disabled.
        </p>
      )}
    </div>
  );
}
